"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/require-default-props */
const react_1 = __importStar(require("react"));
const assets_1 = require("~/assets");
const useTimer_1 = __importDefault(require("~/hooks/useTimer"));
const Notification_scss_1 = __importDefault(require("./Notification.scss"));
const Notification = ({ id, message, timeout = 5, type = 'info', onDestroy = () => {
    /* do nothing */
}, }) => {
    const [show, setShow] = (0, react_1.useState)(true);
    let timer = (0, useTimer_1.default)(timeout, () => setShow(false));
    (0, react_1.useEffect)(() => {
        timer === null || timer === void 0 ? void 0 : timer.start();
        return () => {
            timer = null;
        };
    }, []);
    const finish = () => {
        if (!show) {
            onDestroy(id);
        }
    };
    const pause = () => {
        timer === null || timer === void 0 ? void 0 : timer.pause();
    };
    const resume = () => {
        timer === null || timer === void 0 ? void 0 : timer.start();
    };
    return (react_1.default.createElement("div", { onMouseEnter: pause, onMouseLeave: resume, className: `${Notification_scss_1.default.notification} ${Notification_scss_1.default[type]} ${show ? Notification_scss_1.default.in : Notification_scss_1.default.out}`, onAnimationEnd: finish },
        type === 'info' && react_1.default.createElement("img", { src: assets_1.svgFlashInfo }),
        type === 'success' && react_1.default.createElement("img", { src: assets_1.svgFlashSuccess }),
        (type === 'error' || type === 'warning') && react_1.default.createElement("img", { src: assets_1.svgFlashError }),
        react_1.default.createElement("div", { className: Notification_scss_1.default.message }, message)));
};
exports.default = Notification;
